import React from 'react';
import { startRazorpayPayment } from '../services/paymentService';

const RazorpayButton = ({ amount = 100, receipt = 'test_receipt' }) => {
  const handlePayment = () => {
    startRazorpayPayment({
      amount,
      receipt,
      onSuccess: (response) => {
        alert('Payment Success! Payment ID: ' + response.razorpay_payment_id);
      },
      onFailure: (response) => {
        alert('Payment Failed! ' + (response.error && response.error.description));
      },
    });
  };

  return (
    <button onClick={handlePayment} style={{ padding: '10px 20px', background: '#3399cc', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
      Pay with Razorpay
    </button>
  );
};

export default RazorpayButton; 